import { Component } from 'react';
import { string } from 'prop-types';

class ScrollToTopOnMount extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (this.props.identifier !== prevProps.identifier) {
      window.scrollTo({
        behavior: 'smooth',
        top: 0,
      });
    }
  }

  render() {
    return null;
  }
}

export default ScrollToTopOnMount;

ScrollToTopOnMount.propTypes = {
  /** A unique identifier that can be passed to check if the component needs to update.
   *  When this is not defined it will only scroll to top on mount.
   */
  identifier: string,
};
